function Base64ToArrayBuffer(base64: any) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}
export function DownloadExport(data: any) {
  const a = window.document.createElement("a");
  a.href = window.URL.createObjectURL(new Blob([Base64ToArrayBuffer(data.dataByte)], { type: data.contentType }));
  a.download = data.fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
